import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";

/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-04-29 23:43:54
 * @LastEditors  : 程哲林
 * @LastEditTime : 2024-01-30 11:31:44
 * @FilePath     : /marketing-landing-fe/src/utils/request.ts
 * @Description  : 未添加文件描述
 */
// https://api.fat.jojoread.com/pc/pc-aegis/user/operate/log/uploadLog
// https://api.fat.jojoread.com/pc/pc-aegis/user/operate/log/noAuth/uploadLog
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { getSupport } from '@jojo/browser-format-support';
import { customError } from '@woulsl/sentry-config'; // import storage from '@woulsl/storage';

import Cookies from 'js-cookie';
import QS from 'qs';
import { APP_NAME, AUTH_SIGN_URL, DEBUG_HEADER_INFO, isJoJoUp, MOCK, MOCK_BASE_URL, PACKAGE_NAME, TASK_ID } from '@/const';
import mockApimap from '@/const/mock';
import Login from '@/modules/Login';
import { getCurrPlatform, isJoJoReadBrowser, isJoJoUpBrowser, isMatrixAppBrowser, isWXMiniAppBrowser, setSubDomainCookies } from '@/utils'; // import { isJoJoBrowser, isWXBrowser } from './index';

import { jojoAppDirectLogin } from './bridge';
import { toAuthrize } from './toAuthorize';
var isMatrixApp = isMatrixAppBrowser();
var isMiniApp = isWXMiniAppBrowser();
var login = new Login(); // login.show('测试');

var imgSupport = '';
getSupport().then(function (data) {
  imgSupport = data;
});
var isMock = MOCK === '1';
var platform = null;

function ajax(_a) {
  var method = _a.method,
      url = _a.url,
      _b = _a.data,
      data = _b === void 0 ? {} : _b,
      _c = _a.headers,
      headers = _c === void 0 ? {} : _c;
  return new Promise(function (resolve, reject) {
    var request = new XMLHttpRequest();
    var methodStr = method.toUpperCase();
    request.open(methodStr, url, true);
    request.withCredentials = true;
    request.timeout = 15000;

    for (var _i = 0, _a = Object.entries(headers); _i < _a.length; _i++) {
      var _b = _a[_i],
          key = _b[0],
          val = _b[1];

      if (val) {
        request.setRequestHeader(key, val);
      }
    }

    request.setRequestHeader('content-type', 'application/json');

    request.onload = function () {
      if (request.status >= 200 && request.status < 400) {
        var resp = request.responseText;
        resolve(JSON.parse(resp));
      } else {
        reject(request);
      }
    };

    request.onerror = function (e) {
      reject(e);
    };

    switch (methodStr) {
      case 'GET':
        request.send();
        break;

      case 'POST':
        request.send(data);
        break;

      case 'PUT':
        request.send(data);
        break;

      default:
        {
          request.send();
        }
    }
  });
} // 去鉴权判断


var jumpAuthStatus = false;

var request = function request(options) {
  return __awaiter(void 0, void 0, void 0, function () {
    var idx, _a, baseUrl, action, _b, params, _c, prefix, _d, authPrefix, auth, _e, method, _f, jumpAuth, _g, headers, authEnv, reqPrefix, isGet, query, origin, completeBaseUrl, fetchUrl, cookiePackageName, appBundleIdentifier, TMUserAgent;

    return __generator(this, function (_h) {
      switch (_h.label) {
        case 0:
          if (!!platform) return [3
          /*break*/
          , 2];
          return [4
          /*yield*/
          , getCurrPlatform()];

        case 1:
          idx = _h.sent();
          platform = ['jojoApp', 'wx', 'miniApp', 'other'][idx];
          _h.label = 2;

        case 2:
          _a = options.baseUrl, baseUrl = _a === void 0 ? '' : _a, action = options.action, _b = options.params, params = _b === void 0 ? {} : _b, _c = options.prefix, prefix = _c === void 0 ? '/noRight' : _c, _d = options.authPrefix, authPrefix = _d === void 0 ? '/api/fe' : _d, auth = options.auth, _e = options.method, method = _e === void 0 ? 'GET' : _e, _f = options.jumpAuth, jumpAuth = _f === void 0 ? true : _f, _g = options.headers, headers = _g === void 0 ? {} : _g;
          authEnv = Array.isArray(auth) ? auth : ['jojoApp', 'wx', 'miniApp'];

          if (typeof auth === 'boolean') {
            authEnv = auth ? ['jojoApp', 'wx', 'miniApp', 'other'] : [];
          }

          reqPrefix = ''; // 需要鉴权的

          if (authEnv.includes(platform)) {
            reqPrefix = authPrefix;
          } else {
            reqPrefix = prefix;
          }

          isGet = /get/gim.test(method);
          query = isGet ? QS.stringify(params) : '';
          origin = window.location.origin;
          completeBaseUrl = /^http.*/.test(baseUrl) ? baseUrl : "".concat(origin).concat(baseUrl);
          fetchUrl = "".concat(completeBaseUrl).concat(reqPrefix).concat(action).concat(query ? "?".concat(query) : ''); // 配置mockApi

          if (isMock && mockApimap[action]) {
            fetchUrl = "".concat(MOCK_BASE_URL).concat(reqPrefix).concat(action).concat(query ? "?".concat(query) : '');
          }

          cookiePackageName = Cookies.get('packageName') || '';
          appBundleIdentifier = cookiePackageName || PACKAGE_NAME;
          TMUserAgent = __assign(__assign({
            'X-MS-ENHANCE-EXT-RPLC': imgSupport,
            'TM-UserAgent-appUserAuthToken': Cookies.get('authToken') || '',
            'TM-UserAgent-deviceUniqueIdentifier': Cookies.get('deviceId') || '',
            'TM-UserAgent-appBundleIdentifier': appBundleIdentifier
          }, headers || {}), {
            // 静默授权跨域设置
            'TM-UserAgent-wxOpenId': isMiniApp ? Cookies.get('minOpenId') || '' : Cookies.get('openId') || '',
            'TM-UserAgent-wxAppId': isMiniApp ? Cookies.get('minAppId') || '' : Cookies.get('wxAppId') || '',
            'TM-UserAgent-wxMarketingId': Cookies.get('marketingOpenId') || ''
          });

          if (isJoJoUp) {
            TMUserAgent['TM-UserAgent-appAlias'] = 'flawless';
          }

          if (isMatrixApp && APP_NAME !== 'matrix') {
            // 矩阵app内&jojo链路才添加该请求头
            TMUserAgent['TM-UserAgent-appChainIdentifier'] = 'marketing';
          }

          return [2
          /*return*/
          , ajax({
            url: fetchUrl,
            headers: __assign(__assign({}, TMUserAgent), DEBUG_HEADER_INFO || {}),
            method: options.method || 'get',
            data: JSON.stringify(params)
          }).then(function (data) {
            var status = (data || {}).status;
            var needAuth = [1001, 1005].includes(status);
            var needNewOpenId = [1002].includes(status); // 如果需要登录的话，执行一下登录凭证cookie清空

            if (uc_switch) {
              // 识别调用这个接口的情况下
              if (status && needAuth) {
                setSubDomainCookies('authToken', '', {
                  expires: 0
                });
                setSubDomainCookies('uid', '', {
                  expires: 0
                });
              }
            }

            var isFeApi = fetchUrl.indexOf('/api/fe/') > -1;

            if (isFeApi) {
              __store.logged = !needAuth;
            }

            var isPass = (data === null || data === void 0 ? void 0 : data.resultCode) === 200 || (data === null || data === void 0 ? void 0 : data.code) === 'SUCCESS';

            if (!isPass && !needAuth) {
              /* const err = new CustomError({
                name: '接口错误',
                message: data?.errorMsg || data?.message || '接口请求错误'
              });
              Sentry.captureException(err, {
                level: Sentry.Severity.Warning,
                extra: {
                  fetch: fetchUrl,
                  params,
                  response: data
                }
              }); */
              customError({
                name: '接口错误',
                message: (data === null || data === void 0 ? void 0 : data.errorMsg) || (data === null || data === void 0 ? void 0 : data.message) || '接口请求错误',
                captureContext: {
                  level: 'warning',
                  extra: {
                    fetch: fetchUrl,
                    params: params,
                    response: data
                  }
                }
              });
            }

            if (needAuth && !jumpAuthStatus && jumpAuth) {
              jumpAuthStatus = true; // 只有对应租户下的对应app可以使用app登录
              // 领课链路未部署矩阵

              var isAllJOJO = isJoJoReadBrowser() && !isJoJoUp;
              var isAllJOJOUP = isJoJoUpBrowser() && isJoJoUp;
              var canUseBridgeLogin = isAllJOJO || isAllJOJOUP;

              if (platform === 'jojoApp' && canUseBridgeLogin) {
                jojoAppDirectLogin('', function () {
                  jumpAuthStatus = false;
                });
                return data;
              }

              if (AUTH_SIGN_URL) {
                // uc开关开启后
                if (uc_switch) {
                  var redirectUrl = toAuthrize({}); // CHECK 支付的1001 返回authWechatAppId

                  if (data.authWechatAppId) {
                    redirectUrl = toAuthrize({
                      appId: data.authWechatAppId,
                      mode: 3,
                      wechatAuthType: 2,
                      type: 'pay'
                    });
                  }

                  window.location.replace(redirectUrl);
                } else {
                  // uc开关关闭，和源逻辑一样 弹窗授权
                  var redirectUrl = toAuthrize({
                    appId: data.authWechatAppId
                  });
                  login.show(redirectUrl, function () {
                    jumpAuthStatus = false;
                  });
                }
              } // 授权并中断所有代码执行


              throw new Error('请求未授权前往授权');
            } // CHECK 需要新的openId 且 uc开关开启的时候


            if (needNewOpenId && uc_switch) {
              var redirectUrl = toAuthrize({
                appId: data.authWechatAppId,
                mode: 3,
                wechatAuthType: 2,
                type: 'pay'
              });
              window.location.replace(redirectUrl);
            } // 写入TASK_ID


            if (action.includes('point-report-msg')) {
              sessionStorage.setItem(TASK_ID, (data === null || data === void 0 ? void 0 : data.data) || '');
            }

            return data;
          })];
      }
    });
  });
};

export default request;